import React, { useState } from "react";
import SubHeaderComponent from "../components/SubHeaderComponent";
import ProductComponent from "../components/ProductComponent";
import "./peleti-page.css";
import LemnDeFocTextComponent from "../components/LemnDeFocTextComponent";

export default function LemnDeFocPage() {
  const getImage = (image) => {
    switch (image) {
      case 1:
        return require("../assets/lemn-5kg.jpeg");
      case 2:
        return require("../assets/lemn-09mc.jpeg");
      default:
        return;
    }
  };

  const prod1 = {
    name: "Lemn de gratar 5kg",
    price: "25 RON",
    image: 1,
  };
  const prod2 = {
    name: "Lemn de foc 0.9 metru cub",
    price: "1200 RON",
    image: 2,
  };
  const prods = [prod1, prod2];

  const [products, setPeleti] = useState(prods);

  return (
    <div>
      <SubHeaderComponent text={"Lemn de foc si de gratar premium"} />

      <div className="product-container">
        {products.map((prod) => {
          return <ProductComponent prod={prod} getImage={getImage} />;
        })}
      </div>
      <LemnDeFocTextComponent />
    </div>
  );
}
